import gsap from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import ScrollMagic from "scrollmagic";
import _ from "lodash";
import {is_mobile} from "./utils";

require("intersection-observer");

//
// GSAP
//

// GSAP plugins
gsap.registerPlugin(ScrollTrigger);

// GSAP global config
gsap.defaults({
  ease: "linear",
  duration: 1,
  overwrite: "auto"
});

//
// Canvas utils
//

// Update canvas frames
function updateFrames(target, obj) {
  if (target) {
    let frame = Math.round(obj.value * (target.options.frameCount - 1));

    if (frame !== target.options.frameCount - 1 && target.videoLoaded) {
      target.currentFrame = frame;
    } else if (target) {
      // target.currentFrame = "last"
    }
    target.draw();
  }
}

//
// GSAP utils
//
function perform_scene_easing(updateEasingScenes, easeScenes) {
  gsap.ticker.add(function () {
    if (!updateEasingScenes) {
      for (let i = 0; i < easeScenes.length; i++) {
        easeScenes[i].follower.progress(easeScenes[i].tween.progress());
      }

      return;
    }

    for (let i = 0; i < easeScenes.length; i++) {
      let diff =
        easeScenes[i].tween.progress() - easeScenes[i].follower.progress();

      if (Math.abs(diff) < 0.01) {
        continue;
      }

      easeScenes[i].follower.progress(
        easeScenes[i].follower.progress() + diff * 0.07
      );
    }
  });
}

const upd_seq = _.throttle(function (seq, data) {
  updateFrames(seq, data);
}, 16);

//
// Frame cover animation
//
function frame_cover_animation(controller, scrollingScenes) {
  let text = document.querySelector(".main-frame__text");
  let zoom = document.querySelector(".main-frame__zoom");

  if (text && zoom) {
    let textBox = text.getBoundingClientRect();
    let zoomBox = zoom.getBoundingClientRect();

    let push = Math.abs(
      textBox.top + textBox.height / 2 - (zoomBox.top + zoomBox.height / 2)
    );
    if (textBox.height > zoomBox.height)
      push = Math.abs(textBox.bottom - zoomBox.bottom);

    let tween;
    tween = gsap.timeline({});

    let scene = new ScrollMagic.Scene({
      triggerElement: ".main-frame__text",
      triggerHook: 0.3,
      duration: push * 2
    })
      .setPin(".main-frame__text p", {
        pushFollowers: false
      })
      .setTween(tween)
      .addTo(controller);

    document
      .querySelector(".main-frame__zoom img")
      .addEventListener("load", function () {
        let textBox = text.getBoundingClientRect();
        let zoomBox = zoom.getBoundingClientRect();
        let push = Math.abs(
          textBox.top + textBox.height / 2 - (zoomBox.top + zoomBox.height / 2)
        );
        if (textBox.height > zoomBox.height)
          push = Math.abs(textBox.bottom - zoomBox.bottom);

        scene.duration(push);
      });

    scrollingScenes.push({
      tween: tween,
      scene: scene,
      update: function () {
        let textBox = text.getBoundingClientRect();
        let zoomBox = zoom.getBoundingClientRect();
        let push = Math.abs(
          textBox.top + textBox.height / 2 - (zoomBox.top + zoomBox.height / 2)
        );
        if (textBox.height > zoomBox.height)
          push = Math.abs(textBox.bottom - zoomBox.bottom);

        scene.duration(push);
      }
    });
  }
}

//
// City animation
//

// Intro folding animation (desktop)
function city_intro_scroll(folding) {
  console.log("work");
  let obj = {
    value: 0
  };

  gsap.to(obj, {
    scrollTrigger: {
      trigger: "#city_intro_bg",
      start: "top top",
      end: "bottom top",
      scrub: 0.5
    },
    value: 1,
    ease: "power1.out",
    onUpdate: () => {
      updateFrames(folding, obj);
    }
  });

  // Intro text fade
  gsap.to("#city_intro .hide-on-scroll", {
    scrollTrigger: {
      trigger: "#city_intro .hide-on-scroll",
      start: "bottom bottom",
      end: "bottom 95%",
      scrub: true
    },
    autoAlpha: 0
  });

  // gsap.to("#rear_light", {
  //     scrollTrigger: {
  //         trigger: "#rear_img",
  //         start: "top center",
  //         end: "top 33%",
  //         scrub: 1,
  //         // markers: true,
  //     },
  //     autoAlpha: 1
  // });

  // "Conquer the city and beyond" bg transform
  gsap.to("#city_house-bg", {
    scrollTrigger: {
      trigger: "#city_house",
      start: "top center",
      end: "bottom center",
      scrub: 1
    },
    scale: 1.1
  });
}

// Intro folding animation (mobile)
function city_intro_scroll_mobile(folding) {
  let obj = {
    value: 0
  };

  gsap.to(obj, {
    scrollTrigger: {
      trigger: ".index",
      start: "top top",
      end: "240px top",
      pin: "#city_intro_bg",
      scrub: 0.5,
      // refreshPriority: 1,
      //   pinType: "fixed",
      pinSpacing: false
    },
    value: 1,
    duration: 1,
    ease: "power1.out",
    onUpdate: () => {
      updateFrames(folding, obj);
    }
  });

  // Intro text fade
  gsap.to("#city_intro .hide-on-scroll", {
    scrollTrigger: {
      trigger: ".index",
      start: "top top",
      end: "40px top",
      scrub: true
    },
    autoAlpha: 0
  });
}

// CTA scroll animation
function city_cta_scroll() {
  gsap.to("#city_sc_bg", {
    scrollTrigger: {
      trigger: ".city_sc",
      start: "top bottom",
      end: "bottom top",
      scrub: true
    },
    xPercent: 10
  });
}

function city_lights_scroll(headlight) {
  let obj = {
    value: 0
  };

  const upd_headlight_seq = _.throttle(function (self, obj) {
    gsap.to(obj, {
      value: self.progress.toFixed(3),
      duration: 0.2,
      onUpdate: () => {
        updateFrames(headlight, obj);
      }
    });
  }, 50);

  ScrollTrigger.create({
    trigger: "#city_lights",
    start: "top top",
    end: "bottom top",
    pin: "#city_lights_bg",
    pinSpacing: false,
    scrub: 1,
    onUpdate: self => upd_headlight_seq(self, obj)
  });

  document.addEventListener('aos:in:toggle-light', ({detail}) => {
    document.querySelector('.light_mask').classList.toggle('hide');
  });

  // gsap.set(".light_mask", {
  //   scrollTrigger: {
  //     trigger: ".types_bg",
  //     start: "50% center",
  //     end: "50% center",
  //     scrub: 1
  //   },
  //   opacity: 0
  // });
}

// Discover
function city_discover() {
  gsap.from(".city_discover_bg img", {
    scrollTrigger: {
      trigger: ".city_discover_bg",
      start: "top center",
      end: "bottom center",
      scrub: 1
    },
    scale: 1.2
  });
}

// Family
function city_family_scroll() {
  gsap.from("#city_family_bg", {
    scrollTrigger: {
      trigger: "#city_family",
      start: "top center",
      end: "bottom center",
      scrub: 1
    },
    scale: 1.2
  });
}

// Belt
function city_belt_scroll(belt) {
  let obj = {
    value: 0
  };

  gsap.to(obj, {
    scrollTrigger: {
      trigger: "#city_features_belt",
      start: is_mobile ? "top top" : "top 30%",
      end: "bottom bottom",
      scrub: true
    },
    value: 1,
    ease: "power4.inOut",
    onUpdate: () => {
      updateFrames(belt, obj);
    }
  });

  // gsap.from("#city_features_belt_content", {
  //     scrollTrigger: {
  //         trigger: "#city_features_belt_content",
  //         start: "top 75%",
  //         end: "top 25%",
  //         scrub: true,
  //     },
  //     autoAlpha: 0
  // });
}

// Drop
function city_drop_scroll(long) {
  gsap.to("#drop_in", {
    scrollTrigger: {
      trigger: ".city_features_drop-seq",
      start: "top bottom",
      end: "top top",
      scrub: true
      // markers: true
    },
    y: !is_mobile ? "-45vh" : long ? "-50vw" : "-30vw"
  });
}

const grid_scale_real = () => {
  const transform_size = 30

  // 1 линия
  gsap.timeline({
    scrollTrigger: {
      trigger: '.city_highlights .grid',
      start: 'top bottom',
      end: 'top+=25% bottom',
      markers: new URLSearchParams(window.location.search).has("grid-debug"),
      scrub: .3
    }
  })
    .from('.grid-col_1 .grid-card:nth-child(1)', {
      scale: 1.05,
      xPercent: -transform_size / 2,
      yPercent: -transform_size / 2
    }, 0)
    .from('.grid-col_2 .grid-card:nth-child(1)', {
      yPercent: -transform_size / 2 * 3
    }, 0)
    .from('.grid-col_3 .grid-card:nth-child(1)', {
      scale: 1.05,
      xPercent: transform_size / 2,
      yPercent: -transform_size / 2
    }, 0)

  // 2 линия
  gsap.timeline({
    scrollTrigger: {
      trigger: '.grid',
      start: 'top+=20% bottom',
      end: 'top+=45% bottom',
      scrub: .3
    }
  })
    .from('.grid-col_1 .grid-card:nth-child(2)', {
      scale: 1.1,
      xPercent: -transform_size + 10,
      yPercent: -transform_size + 10
    }, 0)
    .from('.grid-col_2 .grid-card:nth-child(2)', {
      yPercent: 0
    }, 0)
    .from('.grid-col_3 .grid-card:nth-child(2)', {
      scale: 1.1,
      xPercent: transform_size - 10,
      yPercent: -transform_size + 10
    }, 0)

  // 3 линия
  gsap.timeline({
    scrollTrigger: {
      trigger: '.grid',
      start: 'top+=40% bottom',
      end: 'top+=65% bottom',
      scrub: .3
    }
  })
    .from('.grid-col_1 .grid-card:nth-child(3)', {
      scale: 1.1,
      xPercent: -transform_size + 20,
      yPercent: -transform_size + 20
    }, 0)
    .from('.grid-col_2 .grid-card:nth-child(3)', {
      yPercent: 0
    }, 0)
    .from('.grid-col_3 .grid-card:nth-child(3)', {
      scale: 1.1,
      xPercent: transform_size - 20,
      yPercent: -transform_size + 20
    }, 0)

  // 4 линия
  gsap.timeline({
    scrollTrigger: {
      trigger: '.grid',
      start: 'top+=60% bottom',
      end: 'top+=85% bottom',
      scrub: .3
    }
  })
    .from('.grid-col_1 .grid-card:nth-child(4)', {
      scale: 1.1,
      xPercent: -transform_size + 30,
      yPercent: -transform_size + 30
    }, 0)
    .from('.grid-col_2 .grid-card:nth-child(4)', {
      yPercent: transform_size
    }, 0)
    .from('.grid-col_3 .grid-card:nth-child(4)', {
      scale: 1.1,
      xPercent: transform_size - 30,
      yPercent: -transform_size + 30
    }, 0)

  window.dispatchEvent(new Event('resize'));
}

const grid_scale = () => {
  let observer = new IntersectionObserver(function (entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        let elem = entry.target;

        if (!elem.dataset.scrollTriggerReady) {
          elem.dataset.scrollTriggerReady = true;

          if (elem.classList.contains("city_highlights")) {
            // imagesLoaded(".city_highlights", grid_scale_real);
            grid_scale_real();
          }
        }
      }
    });
  });

  observer.observe(document.querySelector(".city_highlights"));
}

// function grid_scale() {
//   gsap
//     .timeline({
//       paused: true,
//       scrollTrigger: {
//         trigger: ".grid",
//         start: "top bottom",
//         end: "top center",
//         scrub: true
//       },
//       ease: "expo.out"
//     })
//     .from(
//       ".grid",
//       {
//         scale: 1.3,
//         transformOrigin: "top"
//       },
//       0
//     )
//     .from(
//       ".grid-col_1 .grid-card:nth-child(3)",
//       {
//         xPercent: -30
//       },
//       0
//     )
//     .from(
//       ".grid-col_1 .grid-card:nth-child(1)",
//       {
//         scale: 1.1,
//         xPercent: -10,
//         yPercent: -10
//       },
//       0
//     )
//     .from(
//       ".grid-col_2 .grid-card:nth-child(1)",
//       {
//         yPercent: -20
//       },
//       0
//     )
//     .from(
//       ".grid-col_2 .grid-card:nth-child(2)",
//       {
//         scale: 1.2
//       },
//       0
//     )
//     .from(
//       ".grid-col_2 .grid-card:nth-child(3)",
//       {
//         yPercent: 20
//       },
//       0
//     )
//     .from(
//       ".grid-col_3 .grid-card:nth-child(1)",
//       {
//         scale: 1.1,
//         xPercent: 20,
//         yPercent: -20
//       },
//       0
//     )
//     .from(
//       ".grid-col_3 .grid-card:nth-child(2)",
//       {
//         xPercent: 20
//       },
//       0
//     );
// }

function home_top_banner_anim(banner) {
  let obj = {
    value: 0
  };

  gsap
    .timeline({
      paused: true,
      scrollTrigger: {
        trigger: ".big-banner",
        start: "center bottom",
        end: "center 25%",
        scrub: 1
      }
    })
    .to(obj, 1, {
      value: 1,
      ease: "power4.inOut",
      onUpdate: () => {
        updateFrames(banner, obj);
      }
    })
    .from(
      ".big-banner_inner",
      0.25,
      {
        opacity: 0
      },
      0.55
    );
}

export {
  updateFrames,
  perform_scene_easing,
  frame_cover_animation,
  city_intro_scroll,
  city_intro_scroll_mobile,
  city_cta_scroll,
  city_lights_scroll,
  city_discover,
  city_family_scroll,
  city_belt_scroll,
  city_drop_scroll,
  grid_scale,
  home_top_banner_anim
};
